<template>
  <v-container class="p-plan px-0">
    <v-layout>
      <v-flex grow class="left-section">
        <c-section title="保费试算">
          <h3>美亚和顺保团体意外伤害保险</h3>
          <v-layout class="form-section">
            <v-flex class="form-item form-item-left">
              <label class="form-item-label">保障期限</label>
              <v-select v-model="form.effectDuration" solo single-line :items="effectDurationList"></v-select>
            </v-flex>
          </v-layout>
          <v-divider />
          <v-layout class="plan-section">
            <v-flex>
              <v-layout align-center>
                <v-flex class="subheading">保障方案</v-flex>
                <v-flex shrink>
                  <v-btn color="primary" flat @click="categoryFindVisible2=true">查看职业分类</v-btn>
                </v-flex>
              </v-layout>
              <InsurancePlanTable
                v-model="amount"
                :code="code"
                :plan-id="form.planId"
                :effect-duration="form.effectDuration"
                :plan-list.sync="planList"
              />
            </v-flex>
          </v-layout>
          <v-divider />
          <v-layout class="plan-total-fee">
            <div class="pay-card">
              <div>
                总保费
                <span class="display-1 primary-text">￥{{ amount.toFixed(2) }}</span>
              </div>
              <v-flex class="mt-2">
                <v-btn class="card-btn" color="primary" large @click="goInsure()">投保</v-btn>
              </v-flex>
            </div>
            <v-flex class="notice-div">
              <div>
                <a class="notice-p primary-text" target="blank" href="http://qihuibao-group.oss-cn-beijing.aliyuncs.com/template/chac/%E4%BA%92%E8%81%94%E7%BD%91%E5%9B%A2%E4%BD%93%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9B%E5%A2%9E%E5%91%98excel%E6%A8%A1%E6%9D%BF.xlsx">《互联网团体意外伤害保险增员excel模板》</a>
              </div>
              <div>
                <a class="notice-p primary-text" target="blank" href="http://qihuibao-group.oss-cn-beijing.aliyuncs.com/template/chac/%E5%92%8C%E9%A1%BA%E4%BF%9D%E4%BA%92%E8%81%94%E7%BD%91%E5%9B%A2%E6%84%8FB%E6%AC%BE_%E8%81%8C%E4%B8%9A%E7%B1%BB%E5%88%AB%E8%A1%A8_1-6%E7%B1%BB%E8%81%8C%E4%B8%9A%20%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E5%9B%A2%E6%84%8F%E4%B8%93%E5%B1%9E%EF%BC%89.xlsx">《职业分类表》</a>
              </div>
              <div>
                <a class="notice-p primary-text" target="blank" href="http://qihuibao-group.oss-cn-beijing.aliyuncs.com/template/chac/11_%E5%92%8C%E9%A1%BA%E4%BF%9D%E4%BA%92%E8%81%94%E7%BD%91%E5%9B%A2%E6%84%8FB%E6%AC%BE_%E6%8A%95%E4%BF%9D%E4%BA%BA%E5%A3%B0%E6%98%8E%EF%BC%88%E7%9B%96%E7%AB%A0%E6%A8%A1%E6%9D%BF%EF%BC%89.pdf">《投保人声明（盖章模板）》</a>
              </div>
            </v-flex>
          </v-layout>
        </c-section>
      </v-flex>
    </v-layout>

<!--    <CategoryFind :comId="'2016'" v-model="categoryFindVisible"></CategoryFind>-->
    <JobCategorySearch :comId="'2017'" v-model="categoryFindVisible2"></JobCategorySearch>
  </v-container>
</template>

<script>
import InsurancePlanTable from "@/components/Order/aigInsureBTable";
//import CategoryFind from "@/components/Order/CategoryFind";
import JobCategorySearch from "@/components/Order/JobCategorySearch";
export default {
  components: {
    InsurancePlanTable,
    //CategoryFind,
    JobCategorySearch
  },
  props: {
    code: String
  },
  data() {
    return {
      categoryFindVisible: false,
      categoryFindVisible2: false,
      effectDurationList: [
        { text: "1年", value: 12 },
        { text: "11个月", value: 11 },
        { text: "10个月", value: 10 },
        { text: "9个月", value: 9 },
        { text: "8个月", value: 8 },
        { text: "7个月", value: 7 },
        { text: "6个月", value: 6 },
        { text: "5个月", value: 5 },
        { text: "4个月", value: 4 },
        { text: "3个月", value: 3 },
        { text: "2个月", value: 2 },
        { text: "1个月", value: 1 }
      ],
      form: {
        // 保障期限
        effectDuration: 12,
        // 产品方案
        planId: 4
      },
      planList: [],
      amount: 0
    };
  },
  methods:{
    goInsure(){
      if (!this.isLogin) {
        this.$store.dispatch("callLogin");
        return false;
      }
      this.$router.push(`/insure/2017`);
    }
  },
  computed: {
    product() {
      return this.$store.getters.getProduct(this.code);
    },
    channelId(){
      if(localStorage.getItem('qihuibao-web-userInfo')){
        return JSON.parse(localStorage.getItem('qihuibao-web-userInfo')).channelId
      }else{
        return 0
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card-btn{
  width: 100%;
}
.p-plan {
  .left-section {
    .form-section {
      padding: 30px 137px 40px 0;
      .form-item {
        width: 245px;
        flex-grow: 0;
        .form-item-label {
          width: 56px;
        }
      }
    }
    .plan-section {
      padding: 20px 0;
    }
    .plan-total-fee{
      position: relative;
      padding-top: 10px;
      height: 100px;
      .pay-card{
        position: absolute;
        right: 10px;
      }
      .notice-div{
        position: absolute;
      }
    }
  }
}
</style>

